import { API_URL } from "config";
import Http from "util/https";
import { MstOption, MstOptionsResponseApi } from "../types";

/**
 * CSVオプションApi
 * @returns MstOption[]
 */
export default async function getMstMainOptionsApi() {
  const http = Http.default.alterAuth({useToken: true});
  const url = `${API_URL}/general/master/list`;
  const res = await http.post<MstOptionsResponseApi>(url, {});
  console.log(res.data);

  const options: MstOption[] = res.data.masters.map(m => ({
    tableName: m.table_name,
    displayName: m.display_name,
    lastUpdate: m.last_update,
  }))

  return options;
}
